import { IApplicationState } from '../types/redux';

export function selectIntro(state: IApplicationState) {
  return state.page.intro;
}
